import { faEnvelope as farEnvelope } from "@awesome.me/kit-3777c2145e/icons/classic/regular";
import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import { Button, List } from "bm-ui-kit";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

interface Props extends AbstractStepProps {
	calculatedDifference: number;
}

export class Result extends AbstractStep<{}, Props> {
	protected renderContent(): ReactNode {
		const { calculatedDifference } = this.props;
		return (
			<>
				<Card.Header className="bg-success-700">
					<div className="text-white text-center">
						<p>
							A megadott adatok alapján <span className="text-gold">jogosult lehetsz</span> a 3%-os
							kedvezményes első lakásvásárlási hitelre!
						</p>
						<p className="m-0 mt-3 h4">
							Egy normál piaci hitelhez képest 25 éves futamidő alatt legalább{" "}
							<strong className="d-block text-gold m-0 font-weight-bold display-2">
								{formatText(calculatedDifference, "ft")}
							</strong>
							összeget spórolhatsz.
						</p>
					</div>
				</Card.Header>
				<Card.Body className="text-white text-center bg-success">
					<div className="d-flex justify-content-center mb-4">
						<FontAwesomeIcon size="2x" icon={farEnvelope} className="text-center text-gold" />
						<p className="font-weight-bold h4 mb-1 ml-1 text-left">A részleteket elküldjük e-mailben:</p>
					</div>
					<List variant="gold" itemStyle="tick" className="text-left font-weight-bold h5 mb-5">
						<List.Item>Mit jelent Neked mindez havi törlesztőben</List.Item>
						<List.Item>Mikor és hogyan kaphatod meg</List.Item>
						<List.Item>Milyen termékekkel tudod kombinálni a kedvezményes hitelt</List.Item>
						<List.Item>Azonnal értesítünk az indulásról és friss részletekről</List.Item>
					</List>
				</Card.Body>
				<Card.Footer className="bg-success-500 px-2 py-3">
					<Button type="submit" variant="gold" block>
						Kérem a részletes eredményem
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Result";
	}
}
